import styles from "../blocks/core/HeaderBlock.module.css";

const HamburgerIcon = (backgroundColor: string, isMenuOpen: boolean) => {
  return (
    <div className={styles.bb_minimalism_hamburgerIcon}>
      <span
        className={`${styles.bb_minimalism_hamburgerLine} ${
          isMenuOpen ? styles.bb_minimalism_hamburgerLine_active : ""
        }`}
        style={{ backgroundColor: backgroundColor }}
      />
      <span
        className={`${styles.bb_minimalism_hamburgerLine} ${
          isMenuOpen ? styles.bb_minimalism_hamburgerLine_active : ""
        }`}
        style={{ backgroundColor: backgroundColor }}
      />
      <span
        className={`${styles.bb_minimalism_hamburgerLine} ${
          isMenuOpen ? styles.bb_minimalism_hamburgerLine_active : ""
        }`}
        style={{ backgroundColor: backgroundColor }}
      />
    </div>
  );
};

export default HamburgerIcon;
